import { useEffect, type ReactElement } from 'react'
import { createFileRoute, useLocation } from '@tanstack/react-router'

function LegacyAssignAccountsRedirect(): ReactElement {
  const { searchStr } = useLocation()

  useEffect(() => {
    window.location.replace(`/areaManagement${searchStr}`)
  }, [searchStr])

  return <div />
}

export const Route = createFileRoute('/assignAccounts/')({
  component: LegacyAssignAccountsRedirect,
})
